import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";
import { breadcrumbSlot } from "@redotech/arbiter/breadcrumb";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { UserContextValue } from "@redotech/redo-merchant-app-common/user";
import { TranslatedBreadcrumbLayout } from "../../../return/returns-breadcrumb-label";

function redoAdminOnly({
  user,
}: {
  user: NonNullable<UserContextValue>;
}): boolean {
  return isRedoEmailAddress(user.email);
}

const productsBreadcrumb = breadcrumbSlot();

export const plgProductsRoutes: PermissionedRouteObject[] = [
  {
    element: (
      <TranslatedBreadcrumbLayout
        breadcrumb={productsBreadcrumb}
        getLabel={(t) => t("Products")}
      />
    ),
    handle: { breadcrumb: productsBreadcrumb, permission: redoAdminOnly },
    children: [
      {
        index: true,
        async lazy() {
          const { PlgProductsPage } =
            await import("../../../plg/plg-products-page");
          return { Component: PlgProductsPage };
        },
      },
    ],
  },
];
